import React from 'react';
import { Mail, Phone, Heart } from 'lucide-react';
import { contactInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-pink-600 via-rose-500 to-pink-500 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-11 h-11 rounded-full bg-white flex items-center justify-center">
                <span className="font-display text-pink-600 font-bold text-xl italic">S</span>
              </div>
              <div className="flex flex-col leading-tight">
                <span className="font-display font-semibold text-lg italic">Pink Nails</span>
                <span className="text-xs text-white/80">In-Studio Nail Services</span>
              </div>
            </div>
            <p className="text-white/85 leading-relaxed max-w-sm">
              Professional nail care with a passion for detail. Book your perfect set today and
              experience the S Pink Nails difference.
            </p>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-white/85">
              {['About', 'Services', 'Gallery', 'Testimonials', 'Contact'].map((l) => (
                <li key={l}>
                  <a href={`#${l.toLowerCase()}`} className="hover:text-white transition">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-white/85 text-sm">
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4" /> {contactInfo.phone}
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4" /> {contactInfo.email}
              </li>
              <li>{contactInfo.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/20 flex flex-col sm:flex-row items-center justify-between gap-3 text-white/80 text-sm">
          <p>
            &copy; {new Date().getFullYear()} S Pink Nails Spa. All rights reserved.
          </p>
          <p className="inline-flex items-center gap-1.5">
            Made with <Heart className="h-3.5 w-3.5 fill-white" /> for beautiful nails
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
